<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">
              <a-form-item label="分销商id" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入分销商id" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="statue">
                <a-select v-model="queryParam.statue" placeholder="请选择审核状态" allow-clear>
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="1">已通过</a-select-option>
                  <a-select-option value="2">已驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="视频标题" prop="videoTitle">
                  <a-input v-model="queryParam.videoTitle" placeholder="请输入视频标题" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="播放量" prop="viewCount">
                  <a-input v-model="queryParam.viewCount" placeholder="请输入播放量" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="奖励金额" prop="rewardAmount">
                  <a-input v-model="queryParam.rewardAmount" placeholder="请输入奖励金额" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="审核原因" prop="reason">
                  <a-input v-model="queryParam.reason" placeholder="请输入审核原因" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:distributorReward:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:distributorReward:edit']">
          <a-icon type="edit" />审核
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:distributorReward:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:distributorReward:export']">
          <a-icon type="download" />导出
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:distributorReward:edit']" v-if="record.status == 0" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status == 0" v-hasPermi="['user:distributorReward:edit']">
            <a-icon type="edit" />审核
          </a>
          <a-divider type="vertical" v-hasPermi="['user:distributorReward:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:distributorReward:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDistributorReward,listDistributorReward, delDistributorReward } from '@/api/user/distributorReward'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'DistributorReward',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        videoUrl: null,
        videoTitle: null,
        viewCount: null,
        videoContent: null,
        rewardAmount: null,
        statue: null,
        reason: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: '分销商奖励id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '分销商',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '视频链接',
          dataIndex: 'videoUrl',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '视频标题',
          dataIndex: 'videoTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '播放量',
          dataIndex: 'viewCount',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '视频描述',
          dataIndex: 'videoContent',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '奖励金额',
          dataIndex: 'rewardAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'statue',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 0){
              return '待审核'
            }else if(f == 1){
              return '已通过'
            }else{
              return '已驳回'
            }
          }
        },
        {
          title: '审核原因',
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询分销商奖励列表 */
    getList () {
      this.loading = true
     pageDistributorReward(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        videoUrl: undefined,
        videoTitle: undefined,
        viewCount: undefined,
        videoContent: undefined,
        rewardAmount: undefined,
        statue: undefined,
        reason: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDistributorReward(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-distributor-reward/export', {
            ...that.queryParam
          }, `分销商奖励_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
